const APPROVAL_REQUIRED_STATUS = "ApprovalRequired";

export const hasApprovalRequiredStatus = (validationResponseBody: any) =>
  validationResponseBody?.commandExecutionResultSet?.some(
    (item: any) => item?.Status === APPROVAL_REQUIRED_STATUS
  ) ?? false;
